export const MODULE_DELETE_RESET = 'MODULE_DELETE_RESET'
export const MODULE_DELETE_SET_ERROR = 'MODULE_DELETE_SET_ERROR'
export const MODULE_DELETE_SET_DELETED = 'MODULE_DELETE_SET_DELETED'
export const MODULE_DELETE_TOGGLE_LOADING = 'MODULE_DELETE_TOGGLE_LOADING'
